import { useId } from "react";
import { motion } from "framer-motion";

export function Wash({ color = "#FFD166", size = 460, opacity = 0.4, className = "" }) {
  return (
    <motion.div
      aria-hidden="true"
      className={`pointer-events-none absolute ${className}`}
      style={{ width: size, height: size, opacity }}
      animate={{ scale: [1, 1.07, 1], rotate: [0, 5, 0] }}
      transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
    >
      <div
        className="h-full w-full"
        style={{
          borderRadius: "58% 42% 55% 45% / 45% 58% 42% 55%",
          background: `radial-gradient(circle at 35% 35%, ${color} 0%, ${color}55 45%, ${color}00 72%)`,
          filter: "blur(34px)",
        }}
      />
    </motion.div>
  );
}

const Bloom = ({ x, y, s = 1, color, rot = 0, fid }) => (
  <g transform={`translate(${x},${y}) rotate(${rot}) scale(${s})`}>
    <circle r="26" fill={color} opacity="0.22" filter={`url(#${fid})`} />
    {[0.3, 0.45, 0.6].map((op, layer) => (
      <g key={layer} opacity={op} transform={`rotate(${layer * 8})`}>
        {[0, 72, 144, 216, 288].map((a) => (
          <path
            key={a}
            d="M0 0C-10-14-8-30 0-34C8-30 10-14 0 0Z"
            fill={color}
            transform={`rotate(${a + layer * 5})`}
          />
        ))}
      </g>
    ))}
    <circle r="5" fill="#E8A13C" opacity="0.85" />
  </g>
);

export function Sprig({ color = "#F472B6", leaf = "#7D9B76", className = "", flip = false }) {
  const id = useId();
  const fid = `wcbl-${id.replace(/[^a-zA-Z0-9]/g, "")}`;
  return (
    <motion.svg
      viewBox="0 0 120 210"
      aria-hidden="true"
      className={`pointer-events-none absolute ${className}`}
      animate={{ rotate: [0, 2.5, 0] }}
      transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
    >
      <defs>
        <filter id={fid} x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="7" />
        </filter>
      </defs>
      <g transform={flip ? "scale(-1,1) translate(-120,0)" : undefined}>
        <path d="M64 205C58 165 72 120 62 62" stroke={leaf} strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <path d="M63 160C50 152 42 152 34 158C44 166 54 166 63 160Z" fill={leaf} opacity="0.75" />
        <path d="M64 128C76 118 86 118 94 126C82 134 72 134 64 128Z" fill={leaf} opacity="0.7" />
        <path d="M63 96C52 90 45 90 38 95C47 102 56 102 63 96Z" fill={leaf} opacity="0.65" />
        <Bloom x={62} y={50} s={1.05} color={color} fid={fid} />
        <Bloom x={92} y={88} s={0.62} color={color} rot={30} fid={fid} />
        <Bloom x={38} y={118} s={0.5} color={color} rot={-20} fid={fid} />
      </g>
    </motion.svg>
  );
}
